import { Controller } from '@hotwired/stimulus';
import { DrawerController } from '@elc-online/edl-components/js/drawer';

export default class extends Controller<HTMLElement> {
  static readonly targets = [
    'content',
    'close',
    'trigger',
    'container',
    'form',
  ];
  static readonly values = { position: String };

  declare contentTarget: HTMLElement;
  declare closeTarget: HTMLButtonElement;
  declare triggerTarget: HTMLButtonElement;
  declare hasTriggerTarget: boolean;

  private edlController: typeof DrawerController = null;

  initialize() {
    this.edlController = new DrawerController(
      {
        close: this.closeTarget,
        drawer: this.contentTarget,
        trigger: this.triggerTarget,
      },
      { mode: 'auto' },
    );
  }

  // TODO: Remove after EDL-136
  hide = () => {
    this?.edlController?.close();
  };
}
